// Module
var code = `<div class="table-panel-container">
  <div class="table-panel-header-bg" ng-show="ctrl.table.rows.length"></div>
  <div class="table-panel-scroll" ng-show="ctrl.table.rows.length">
    <table class="table-panel-table">
      <thead>
        <tr>
          <th ng-repeat="col in ctrl.table.columns" ng-if="!col.hidden">
            <div class="table-panel-table-header-inner pointer" ng-click="ctrl.toggleColumnSort(col, \$index)">
              {{col.title}}
              <span class="table-panel-table-header-controls" ng-if="col.sort">
                <icon name="'angle-down'" ng-show="col.desc"></icon>
                <icon name="'angle-up'" ng-hide="col.desc"></icon>
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
  </div>
</div>
<div class="datapoints-warning" ng-show="ctrl.table.rows.length===0">
  <span class="small"> No data to show <tip>Nothing returned by data query</tip> </span>
</div>
<div class="table-panel-footer"></div>
`;
// Exports
var _module_exports =code;;
var path = 'public/app/plugins/panel/table-old/module.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;